// Thin client for the Pages Function proxy. The client holds NO tokens or API keys —
// the Function injects GIS auth and forwards The Wave traffic. Everything is /api/*.

const BASE = '/api';

async function req(path, { method = 'GET', body, params } = {}) {
  let url = `${BASE}/${path.replace(/^\/+/, '')}`;
  if (params) {
    const qs = new URLSearchParams(params).toString();
    if (qs) url += `?${qs}`;
  }
  const init = { method, headers: {} };
  if (body !== undefined) {
    init.headers['Content-Type'] = 'application/json';
    init.body = JSON.stringify(body);
  }
  const resp = await fetch(url, init);
  const text = await resp.text();
  let data;
  try { data = text ? JSON.parse(text) : null; } catch { data = text; }
  if (!resp.ok) {
    const msg = (data && (data.message || data.error)) || resp.statusText;
    throw new Error(`API ${method} ${path} -> ${resp.status}: ${msg}`);
  }
  return data;
}

// ---- GIS: map / geo / spatial-search ----
export const geoSearch = (q, countryCode = 4, maxResults = 5) =>
  req('geo/search', { params: { search_query: q, country_code: countryCode, max_results: maxResults } });

export const geoPostcodes = ({ type = 'pc4', areaType, areaName }) =>
  req('geo/postcodes', { params: { type, area_type: areaType, area_name: areaName } });

export const postcodeAt = (lat, lng, type = 'pc4') =>
  req('geo/postcode-at', { params: { lat, lng, type } });

export const pcSelect = (body) => req('spatial-search/pc-select', { method: 'POST', body });
export const circleSelect = (body) => req('spatial-search/circle', { method: 'POST', body });
export const dtm = (body) => req('dtm', { method: 'POST', body });
export const uploadExtractHeaders = (body) => req('upload/extract-headers', { method: 'POST', body });
export const uploadProcess = (body) => req('upload/process', { method: 'POST', body });

// ---- Saved selections (our own KV via the Function) ----
export const saveSelection = (body) => req('saved', { method: 'POST', body });

// Event log (imports, errors) — fire and forget, never throws, never blocks the UI.
const SESSION = Math.random().toString(36).slice(2, 8);
export function logEvent(payload) {
  try {
    const body = { session: SESSION, lang: localStorage.getItem('segtool.lang') || '', page: location.search, ...payload };
    const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
    if (!(navigator.sendBeacon && navigator.sendBeacon(`${BASE}/log`, blob))) {
      fetch(`${BASE}/log`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), keepalive: true }).catch(() => {});
    }
  } catch { /* logging must never break the tool */ }
}
export const listEvents = () => req('log');
export const getSelection = (id) => req(`saved/${encodeURIComponent(id)}`);
export const listSelections = () => req('saved');

// ---- GIS: Dividuals catalogue ----
export const dividualsAttributes = () => req('dividuals/attributes');

// ---- GIS: aggregate-only count provider (alternative seam) ----
export const gisDividualsCount = (body) => req('dividuals/addresses/count', { method: 'POST', body });

// ---- The Wave / Instadata: counting (via /api/thewave/* seam) ----
// Use count/advanced — it returns filtered totals per block: data.repeatable[<pc>].{dm,em,audience}
// (count/segments returns a per-subsegment histogram, not what we need). Verified live 2026-08-25.
export const waveCountSegments = (body) =>
  req('thewave/audiences/count/advanced', { method: 'POST', body });
